import { Component, OnInit } from "@angular/core"; 
import { apiUrl } from "../../global/global";
import { AdminService } from "../../services/admin.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ImageUrls } from "src/app/services/s3buket";
import * as Highcharts from "highcharts";
import { HttpClient, HttpParams } from "@angular/common/http";
import { DatePipe } from "@angular/common"
import { HighchartsChartModule } from "highcharts-angular"
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsSolidGauge from "highcharts/modules/solid-gauge";

// HighchartsMore(Highcharts);
// HighchartsSolidGauge(Highcharts);
@Component({
  selector: "app-view-myreport",
  templateUrl: "./view-myreport.component.html",
  styleUrls: ["./view-myreport.component.css"]
})
export class ViewMyreportComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts;
  reportData:any;
  recruiterData:any;
  limit = 5;
	skip = 1;
  filter="All"
  daysFilter="90Days";
  appearArowth:any;
  growth:any;
  actionTaken:any;
  profileViewData:any;
  appearData:any;
  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  constructor( public route: ActivatedRoute,  private router: Router, private api: AdminService, public datepipe: DatePipe) { }

  ngOnInit(): void {
    this.getReport();
    this.getReportViewlisting();
    this.getReportRecruiterAction();
    this.getSearchViewGraph();
    this.getSearchAppearanceGraph();
  }

  getReport(){
    this.api.getDatas(apiUrl._getReport)
    .subscribe(async (res) => {
      this.reportData = res.data;  
    })
  }
  getReportViewlisting(){
    let params = new HttpParams(); 
    params = params.append("skip", this.skip.toString());
		params = params.append("limit", this.limit.toString());
		params = params.append("filter", this.filter);
    this.api.getData(apiUrl._getReportViewlisting,params)
    .subscribe(async (res) => {
      console.log(res,"res");
      
    })
  }
  getReportRecruiterAction(){
    let params = new HttpParams(); 
    params = params.append("skip", this.skip.toString());
		params = params.append("limit", this.limit.toString());
		params = params.append("filter", this.filter);
    this.api.getData(apiUrl._getReportRecruiterAction,params)
    .subscribe(async (res) => {
      this.recruiterData = res.data;
    })
  }
  
  dateInMilisecond(date) {
    const d1 = new Date(date)
    const miliSecond = d1.getTime();
    return miliSecond
  }
  onAction(event,number){
    if(number == 1){
      this.filter = "All"
    } else if( number == 2){
      this.filter = "view"
    }else if( number == 3){
      this.filter = "download"
    }else if( number == 4){
      this.filter = "mail"
    }
    this.getReportRecruiterAction();
  }
  //getSearchAppearanceGraph
  getSearchAppearanceGraph(){
    let params = new HttpParams();  
		params = params.append("filter", this.daysFilter);
    this.api.getData(apiUrl._getSearchAppearanceGraph,params)
    .subscribe(async (res) => {
      this.appearData= res.data;  
      this.getGraphGrowth()
      this.createChartLine(this.appearData);
    })
  }
  
  searchAppearanceFilter(event){
    if(event.target.value == "7Days"){
      this.daysFilter = event.target.value;
    } else if(event.target.value == "30Days"){
      this.daysFilter = event.target.value;
    } else if(event.target.value == "90Days"){
      this.daysFilter = event.target.value;
    }
    this.getSearchAppearanceGraph();
  }
  getGraphGrowth() {
    const currentCount:any=this.appearData.current;
    const lastCount:any= this.appearData.last;
    this.appearArowth = currentCount - lastCount;
    const percentage = this.appearArowth / lastCount * 100;
    // console.log(percentage.ceil(),"percentage");
    if (percentage == Infinity || percentage==Number.NaN) {
      return "";
    } else if (percentage == -Infinity) {
      return "${percentage.ceil()}% less action since last ${filterDays.graphFilterLabel()}";
    } else if (!percentage) {
      return "${percentage.ceil()}% more action since last ${filterDays.graphFilterLabel()}";
    } else {
      return "Action is constant as last ${filterDays.graphFilterLabel()}.";
    }
  } 
  private createChartLine(appearData): void { 
    const data:any=[] 
    if (appearData.graph.length == 7){
    for (let i = 0; i < this.appearData.graph.length; i++) {
      data.splice(0,0,[this.datepipe.transform(new Date(this.appearData.graph[i].date), "dd/MM"),this.appearData.graph[i].count])
      // data.push(0,);
    }
  } else {
    let chunkOf10 : any = []
    let chunkLength = appearData.graph.length / 10
    for (let i = 0; i < appearData.graph.length; i += chunkLength) {
      chunkOf10.push(appearData.graph.slice(i, i + chunkLength));
    }
    for (let i = 0; i < chunkOf10.length; i++) {
      let date = this.datepipe.transform(new Date(chunkOf10[i][0].date), "dd/MM") + " - " + this.datepipe.transform(new Date(chunkOf10[i][chunkOf10[i].length - 1].date), "dd/MM")
      let totalCount = 0
      for (let p=0; p< chunkOf10[i].length; p++) {
        totalCount += chunkOf10[i][p].count
      }
      data.splice(0,0,[date,totalCount]);
    }
  }
    const chart = Highcharts.chart("chart-line", {
      chart: {
        type: "line",
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        type: "category"
      },
      tooltip: {
        headerFormat: `<div>Date: {point.key}</div>`,
        pointFormat: `<div>{series.name}: {point.y}</div>`,
        shared: true,
        useHTML: true,
      },
      series: [{
        name: "Search",
        data:data,
      }],
    } as any);
    // setInterval(() => {
    //   date.setDate(date.getDate() + 1);
    //   chart.series[0].addPoint([`${date.getDate()}/${date.getMonth() + 1}`, this.getRandomNumber(0, 1000)], true, true);
    // }, 1500);
  }
  // search view graph
  
  getSearchViewGraph(){
    let params = new HttpParams();  
		params = params.append("filter", this.daysFilter);
    this.api.getData(apiUrl._getSearchViewGraph,params)
    .subscribe(async (res) => {
      this.profileViewData= res.data;  
      this.getSearchViewGraphGrowth()
      this.createChartLine2(this.profileViewData);
    })
  }
  
  getSearchViewGraphGrowth() {
    const currentCount:any=this.profileViewData.current;
    const lastCount:any= this.profileViewData.last;
    this.growth = currentCount - lastCount;
    const percentage = this.growth / lastCount * 100;
    if (percentage == Infinity || Number.isNaN(percentage)) {
      return "";
    } else if (percentage == -Infinity) {
      return "${percentage.ceil()}% less action since last ${filterDays.graphFilterLabel()}";
    } else if (!percentage) {
      return "${percentage.ceil()}% more action since last ${filterDays.graphFilterLabel()}";
    } else {
      return "Action is constant as last ${filterDays.graphFilterLabel()}.";
    }
    // console.log(percentage,"percentage");
  }
  profileFilter(event){
    if(event.target.value == "7Days"){
      this.daysFilter = event.target.value;
    } else if(event.target.value == "30Days"){
      this.daysFilter = event.target.value;
    } else if(event.target.value == "90Days"){
      this.daysFilter = event.target.value;
    }
    this.getSearchViewGraph();
  }
  private createChartLine2(profileViewData): void {
    const data:any=[] 
    if (profileViewData.graph.length == 7){
    for (let i = 0; i < this.profileViewData.graph.length; i++) {
      data.splice(0,0,[this.datepipe.transform(new Date(this.profileViewData.graph[i].date), "dd/MM"),this.profileViewData.graph[i].count]);
    }
  } else {
    let chunkOf10 : any = []
    let chunkLength = profileViewData.graph.length / 10
    for (let i = 0; i < profileViewData.graph.length; i += chunkLength) {
      chunkOf10.push(profileViewData.graph.slice(i, i + chunkLength));
    }
    for (let i = 0; i < chunkOf10.length; i++) {
      let date = this.datepipe.transform(new Date(chunkOf10[i][0].date), "dd/MM") + " - " + this.datepipe.transform(new Date(chunkOf10[i][chunkOf10[i].length - 1].date), "dd/MM")
      let totalCount = 0
      for (let p=0; p< chunkOf10[i].length; p++) {
        totalCount += chunkOf10[i][p].count
      }
      data.splice(0,0,[date,totalCount]);
    }
  }
    const chart = Highcharts.chart("chart-line2", {
      chart: {
        type: "line",
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        type: "category", 
      },
      tooltip: {
        headerFormat: `<div>Date: {point.key}</div>`,
        pointFormat: `<div>{series.name}: {point.y}</div>`,
        shared: true,
        useHTML: true,
      },
      series: [{
        name: "Search",
        data:data,
      }],
    } as any);
    
  }
  // see all redirect
  
  openEmployerDetails(employerId) {
    this.router.navigate(["/employer-choice/details/" + employerId + "/about"]);
  }
}
